module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Reply-all-fe43b6ba10c80f7099f348ca5cec0f2f.svg";